// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {onAuthStateChangedEffect} from './onAuthStateChanged'
import {signInEffect} from './signIn'
import {enterSignInEffect} from './enterSignIn'

export const sessionEffects = [
  onAuthStateChangedEffect,
  signInEffect,
  enterSignInEffect,
]
